// extracted by mini-css-extract-plugin
module.exports = {"actions":"DocumentsActionsCell_actions_2sI7E","error":"DocumentsActionsCell_error_2Vz4E"};